<template>
  <div class="dkb-page">
    <div class="dkb-card">
      <header class="dkb-hero">
        <div class="dkb-hero__main">
          <span class="dkb-hero__icon" aria-hidden="true">
            <CIcon name="navProducts"/>
          </span>
          <div class="dkb-hero__text">
            <h1 class="dkb-hero__title">انتشار گروهی از دیجی‌کالا</h1>
            <p class="dkb-hero__sub" v-if="job">
              لیست محصولات از جستجوی دیجی‌کالا خوانده و در فروشگاه ثبت می‌شود
            </p>
            <p class="dkb-hero__sub" v-else>
              هنوز انتشاری شروع نشده است
            </p>
          </div>
        </div>
        <div class="dkb-hero__actions">
          <button
            v-if="running"
            type="button"
            class="dkb-btn dkb-btn--danger"
            @click="stop = true"
          >
            <span>توقف</span>
          </button>
          <button
            v-if="ok_count && !running"
            type="button"
            class="dkb-btn dkb-btn--ghost"
            @click="copy_links()"
          >
            <CIcon name="iconClone"/>
            <span>کپی لینک‌ها</span>
          </button>
          <button
            type="button"
            class="dkb-btn dkb-btn--primary"
            @click="$router.push('/dashboard/products/create')"
          >
            <CIcon name="iconChevronRight"/>
            <span>بازگشت به افزودن محصول</span>
          </button>
        </div>
      </header>

      <div v-if="job && job.url" class="dkb-source">
        <span class="dkb-source__label">منبع</span>
        <a class="dkb-source__link" :href="job.url" target="_blank" rel="noopener" dir="ltr">{{ job.url }}</a>
      </div>

      <div v-if="!job" class="dkb-empty">
        <span class="dkb-empty__icon" aria-hidden="true">
          <CIcon name="navProducts"/>
        </span>
        <p class="dkb-empty__title">هیچ فرآیند انتشاری در جریان نیست</p>
        <p class="dkb-empty__sub">
          از صفحهٔ «افزودن محصول» دکمهٔ «افزودن گروهی از جستجوی دیجی‌کالا» را بزنید.
        </p>
        <button type="button" class="dkb-btn dkb-btn--primary" @click="$router.push('/dashboard/products/create')">
          <span>رفتن به افزودن محصول</span>
        </button>
      </div>

      <template v-else>
        <div class="dkb-stats" v-if="items.length || running || loading_list">
          <button type="button" class="dkb-stat" :class="{ active: filter === 'all' }" @click="filter = 'all'">
            <span class="dkb-stat__value">{{ items.length || '—' }}</span>
            <span class="dkb-stat__label">کل</span>
          </button>
          <button type="button" class="dkb-stat" :class="{ active: filter === 'done' }" @click="filter = 'done'">
            <span class="dkb-stat__value">{{ done_count }}</span>
            <span class="dkb-stat__label">انجام‌شده</span>
          </button>
          <button type="button" class="dkb-stat dkb-stat--ok" :class="{ active: filter === 'ok' }" @click="filter = 'ok'">
            <span class="dkb-stat__value">{{ ok_count }}</span>
            <span class="dkb-stat__label">موفق</span>
          </button>
          <button type="button" class="dkb-stat dkb-stat--skip" :class="{ active: filter === 'skip' }" @click="filter = 'skip'">
            <span class="dkb-stat__value">{{ skip_count }}</span>
            <span class="dkb-stat__label">تکراری</span>
          </button>
          <button type="button" class="dkb-stat dkb-stat--err" :class="{ active: filter === 'error' }" @click="filter = 'error'">
            <span class="dkb-stat__value">{{ error_count }}</span>
            <span class="dkb-stat__label">خطا</span>
          </button>
        </div>

        <div class="dkb-progress" v-if="items.length">
          <div class="dkb-progress__track" role="progressbar" :aria-valuenow="progress_pct" aria-valuemin="0" aria-valuemax="100">
            <div class="dkb-progress__bar" :style="{ width: progress_pct + '%' }"></div>
          </div>
          <span class="dkb-progress__meta">{{ progress_pct }}٪ — {{ done_count }} از {{ items.length }}</span>
        </div>

        <div class="dkb-toolbar">
          <label class="dkb-field" for="dkb-max-images">
            <span class="dkb-field__label">تعداد عکس هر محصول</span>
            <input
              id="dkb-max-images"
              type="number"
              min="1"
              max="30"
              step="1"
              class="dkb-field__input"
              v-model.number="max_images"
              :disabled="running"
              @change="save_max_images()"
            >
          </label>
          <div v-if="status_text" class="dkb-status" :class="{ 'dkb-status--live': running || loading_list }">
            <span class="dkb-status__dot" v-if="running || loading_list" aria-hidden="true"></span>
            <CSpinner v-if="loading_list" size="sm" class="dkb-status__spin"/>
            <span>{{ status_text }}</span>
          </div>
        </div>

        <div class="dkb-filters" v-if="items.length">
          <button
            v-for="f in filter_options"
            :key="f.value"
            type="button"
            class="dkb-filter"
            :class="{ active: filter === f.value }"
            @click="filter = f.value"
          >
            {{ f.label }}
            <span class="dkb-filter__count">{{ f.count }}</span>
          </button>
          <button
            v-if="done_count && !running"
            type="button"
            class="dkb-btn dkb-btn--sm dkb-btn--ghost dkb-filters__clear"
            @click="hide_done()"
          >
            پاک کردن انجام‌شده‌ها
          </button>
        </div>

        <div v-if="loading_list && !items.length" class="dkb-skel" aria-busy="true">
          <div v-for="n in 5" :key="'sk' + n" class="dkb-skel__row"></div>
        </div>

        <ul class="dkb-list" v-if="filtered_items.length">
          <li
            v-for="(it, i) in filtered_items"
            :key="it.dk_id"
            class="dkb-item"
            :class="'is-' + it.state"
          >
            <div class="dkb-item__index">{{ i + 1 }}</div>
            <div class="dkb-item__thumb">
              <img v-if="it.image" :src="it.image" :alt="it.title" @error="$set(it, 'image', '')"/>
              <span v-else class="dkb-item__thumb-ph" aria-hidden="true">
                <CIcon name="navMedia"/>
              </span>
            </div>
            <div class="dkb-item__main">
              <span class="dkb-item__title" :title="it.title">{{ it.title }}</span>
              <span class="dkb-chip" dir="ltr">dkp-{{ it.dk_id }}</span>
              <span v-if="it.state === 'skip'" class="dkb-hint">تکراری</span>
              <span v-if="it.error" class="dkb-hint dkb-hint--err" :title="it.error">{{ it.error }}</span>
              <span v-if="it.img_warn" class="dkb-hint dkb-hint--warn" :title="it.img_warn_detail">{{ it.img_warn }}</span>
            </div>
            <div class="dkb-item__state" :title="state_label(it.state)">
              <CSpinner v-if="it.state === 'working'" size="sm"/>
              <span v-else class="dkb-badge" :class="'dkb-badge--' + it.state">{{ state_short(it.state) }}</span>
            </div>
            <div class="dkb-item__actions">
              <button
                v-if="it.product_id && it.img_fails && it.img_fails.length"
                type="button"
                class="dkb-btn dkb-btn--sm dkb-btn--warn"
                :disabled="!!it.img_retrying || running"
                title="دانلود مجدد عکس"
                @click="retry_images(it)"
              >
                <CSpinner v-if="it.img_retrying" size="sm"/>
                <span v-else>عکس</span>
              </button>
              <a
                v-if="it.site_link"
                :href="it.site_link"
                target="_blank"
                rel="noopener"
                class="dkb-btn dkb-btn--sm dkb-btn--ghost"
              >سایت</a>
              <router-link
                v-if="it.product_id"
                :to="'/dashboard/products/edit/' + it.product_id"
                target="_blank"
                class="dkb-btn dkb-btn--sm dkb-btn--ghost"
              >ویرایش</router-link>
              <button
                type="button"
                class="dkb-btn dkb-btn--sm dkb-btn--danger"
                title="حذف از این لیست"
                :disabled="running && (it.state === 'working' || it.state === 'waiting')"
                @click="hide_item(it)"
              >
                <CIcon name="iconTrash"/>
                <span>حذف</span>
              </button>
            </div>
          </li>
        </ul>
        <div v-else-if="items.length" class="dkb-empty dkb-empty--soft">
          <p class="dkb-empty__title">موردی با این فیلتر نیست</p>
          <button type="button" class="dkb-btn dkb-btn--ghost" @click="filter = 'all'">نمایش همه</button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
function dkPrice(product) {
  // Digikala: rrp_price = list price, selling_price = actual price (both in Rial). Either may be missing.
  const v = (product && product.default_variant && product.default_variant.price) || {};
  const rrp = Number(v.rrp_price) || 0;
  const sell = Number(v.selling_price) || 0;
  const base = rrp || sell;
  return { price: base ? Math.round(base / 10) : '', off: sell && rrp && sell < rrp ? Math.round(sell / 10) : '' };
}
/** Best-effort thumbnail from Digikala product / our gallery payloads */
function pickImage(...candidates) {
  for (const c of candidates) {
    if (!c) continue;
    if (typeof c === 'string' && /^https?:\/\//i.test(c)) return c;
    if (Array.isArray(c)) {
      const hit = pickImage(...c);
      if (hit) return hit;
      continue;
    }
    if (typeof c === 'object') {
      const hit = pickImage(c.image, c.url, c.src, c.main, c.list && c.list[0]);
      if (hit) return hit;
    }
  }
  return '';
}
import axios from "@/api/http";
const JOB_KEY = 'dk_bulk_job';
const RESULT_KEY = 'dk_bulk_result';

export default {
  name: 'DigikalaBulkImport',
  data() {
    return {
      job: null,
      max_images: (() => { const n = parseInt(localStorage.getItem('dk_bulk_max_images'), 10); return n >= 1 && n <= 30 ? n : 5; })(),
      items: [],
      filter: 'all',
      running: false,
      stop: false,
      loading_list: false,
      status_text: '',
    }
  },
  computed: {
    done_count() { return this.items.filter((x) => x.state === 'ok' || x.state === 'error' || x.state === 'skip').length; },
    ok_count() { return this.items.filter((x) => x.state === 'ok').length; },
    skip_count() { return this.items.filter((x) => x.state === 'skip').length; },
    error_count() { return this.items.filter((x) => x.state === 'error').length; },
    pending_count() { return this.items.filter((x) => x.state === 'waiting' || x.state === 'working').length; },
    progress_pct() {
      if (!this.items.length) return 0;
      return Math.round((this.done_count / this.items.length) * 100);
    },
    filter_options() {
      return [
        { value: 'all', label: 'همه', count: this.items.length },
        { value: 'done', label: 'انجام‌شده', count: this.done_count },
        { value: 'ok', label: 'موفق', count: this.ok_count },
        { value: 'skip', label: 'تکراری', count: this.skip_count },
        { value: 'error', label: 'خطا', count: this.error_count },
        { value: 'pending', label: 'در صف', count: this.pending_count },
      ];
    },
    filtered_items() {
      const f = this.filter;
      if (f === 'all') return this.items;
      if (f === 'done') return this.items.filter((x) => x.state === 'ok' || x.state === 'error' || x.state === 'skip');
      if (f === 'pending') return this.items.filter((x) => x.state === 'waiting' || x.state === 'working');
      return this.items.filter((x) => x.state === f);
    },
  },
  mounted() {
    try { this.job = JSON.parse(localStorage.getItem(JOB_KEY) || 'null'); } catch (e) { this.job = null; }
    if (this.job && this.job.status === 'new') {
      this.job.status = 'running';
      localStorage.setItem(JOB_KEY, JSON.stringify(this.job));
      this.run();
    } else {
      try {
        const saved = JSON.parse(localStorage.getItem(RESULT_KEY) || '[]');
        this.items = saved.map((x) => (x.state === 'working' || x.state === 'waiting') ? Object.assign(x, {state: 'error', error: x.error || 'انجام نشد'}) : x);
      } catch (e) {}
      this.hydrate_missing_images();
    }
  },
  beforeDestroy() {
    this.stop = true;
  },
  methods: {
    async hydrate_missing_images() {
      const need = this.items.filter((x) => x.product_id && !x.image);
      if (!need.length) return;
      try {
        const existing = await this.load_existing();
        let changed = false;
        this.items.forEach((it) => {
          if (it.image) return;
          if (it.product_id && existing.images[it.product_id]) {
            this.$set(it, 'image', existing.images[it.product_id]);
            changed = true;
            return;
          }
          const dup = existing.codes[String(it.dk_id)] || existing.names[this.norm_name(it.title)];
          if (dup && existing.images[dup.id]) {
            this.$set(it, 'image', existing.images[dup.id]);
            if (!it.product_id) this.$set(it, 'product_id', dup.id);
            changed = true;
          }
        });
        if (changed) this.persist();
      } catch (e) {}
    },
    state_short(s) {
      return ({ ok: 'موفق', error: 'خطا', skip: 'تکراری', waiting: 'صف', working: '…' })[s] || s;
    },
    state_label(s) {
      return ({ ok: 'منتشر شد', error: 'خطا در انتشار', skip: 'تکراری', waiting: 'در صف', working: 'در حال انتشار' })[s] || s;
    },
    sleep(ms) { return new Promise((r) => setTimeout(r, ms)); },
    async retry_images(it) {
      if (!it.product_id || !it.img_fails || !it.img_fails.length) return;
      this.$set(it, 'img_retrying', true);
      try {
        const fd = new FormData();
        fd.append('product_id', it.product_id);
        fd.append('urls', JSON.stringify(it.img_fails));
        fd.append('max_images', String(this.max_images));
        const r = await axios.post('/api/admin/product/digikala_retry_images', fd, {show_pros: false});
        const d = r.data || {};
        if (d.error == 1) throw new Error(d.msg || 'error');
        const left = d.image_failures || [];
        this.$set(it, 'img_fails', left.map((x) => x.url));
        if (left.length) {
          this.$set(it, 'img_warn', 'تصاویر ناموفق: ' + left.length);
          this.$set(it, 'img_warn_detail', left.map((x) => x.reason + ' ' + x.url).join('\n'));
        } else {
          this.$set(it, 'img_warn', '');
          this.$set(it, 'img_warn_detail', '');
        }
      } catch (e) {
        const msg = (e && e.response && e.response.data) ? this.error_text(e.response.data) : (e && e.message ? e.message : String(e));
        this.$set(it, 'img_warn_detail', msg);
      } finally {
        this.$set(it, 'img_retrying', false);
        this.persist();
      }
    },
    save_max_images() {
      const n = parseInt(this.max_images, 10);
      this.max_images = isNaN(n) ? 5 : Math.min(30, Math.max(1, n));
      localStorage.setItem('dk_bulk_max_images', String(this.max_images));
    },
    persist() { localStorage.setItem(RESULT_KEY, JSON.stringify(this.items)); },
    api_path(link, page) {
      const u = new URL(link.trim());
      const params = new URLSearchParams(u.search);
      params.set('page', page);
      const cat = u.pathname.match(/\/search\/category-([^/]+)/);
      if (cat) return '/dk-api/v1/categories/' + cat[1] + '/search/?' + params.toString();
      return '/dk-api/v1/search/?' + params.toString();
    },
    async dk_api(apiPath, query) {
      const fd = new FormData();
      fd.append('path', apiPath);
      fd.append('query', query || '');
      const res = await axios.post('/api/admin/product/digikala_api', fd, {show_pros: false});
      if (!res.data || res.data.error === 1) throw new Error((res.data && res.data.msg) || 'خطا در ارتباط با دیجی‌کالا');
      return res.data;
    },
    norm_name(name) {
      return String(name || '').replace(/[\u200c\s]+/g, ' ').replace(/ي/g, 'ی').replace(/ك/g, 'ک').trim().toLowerCase();
    },
    // existing products (by code = Digikala id, or same name) so duplicates are skipped
    dk_thumb(p) {
      if (!p) return '';
      return pickImage(
        p.images && p.images.main,
        p.images && p.images.list,
        p.default_variant && p.default_variant.images,
        p.image
      );
    },
    gallery_thumb(gallery) {
      const g = Array.isArray(gallery) ? gallery[0] : null;
      return pickImage(g && g.image, g);
    },
    hide_item(it) {
      if (!it) return;
      if (this.running && (it.state === 'working' || it.state === 'waiting')) return;
      this.items = this.items.filter((x) => x.dk_id !== it.dk_id);
      this.persist();
    },
    hide_done() {
      this.items = this.items.filter((x) => x.state === 'waiting' || x.state === 'working');
      this.persist();
      if (!this.items.length) this.filter = 'all';
    },
    async load_existing() {
      const res = await axios.post('/api/admin/product/get_products', new FormData(), {show_pros: false});
      const codes = {}, names = {}, slugs = {}, images = {};
      ((res.data && res.data.items) || []).forEach((p) => {
        const name = (p.title && p.title.title) || p.name;
        const thumb = this.gallery_thumb(p.gallery);
        if (p.code !== undefined && p.code !== null && p.code !== '') {
          const code = String(p.code).trim();
          codes[code] = p;
          codes[code.replace(/^dk-/i, '')] = p;
        }
        if (name) names[this.norm_name(name)] = p;
        if (p.title && p.title.slug) slugs[p.id] = p.title.slug;
        if (thumb) images[p.id] = thumb;
      });
      return {codes, names, slugs, images};
    },
    async fetch_list(link, max) {
      const list = [];
      let page = 1, total_pages = 1;
      while (list.length < max && page <= total_pages && !this.stop) {
        const full = this.api_path(link, page).replace(/^\/dk-api/, '');
        const q = full.indexOf('?');
        const json = await this.dk_api(q >= 0 ? full.slice(0, q) : full, q >= 0 ? full.slice(q + 1) : '');
        const data = json.data || {};
        total_pages = (data.pager && data.pager.total_pages) || 1;
        (data.products || []).forEach((p) => {
          if (list.length < max && !list.find((x) => x.dk_id === p.id)) {
            list.push({
              dk_id: p.id,
              title: p.title_fa,
              image: this.dk_thumb(p),
              state: 'waiting',
              error: '',
              product_id: null,
              site_link: '',
            });
          }
        });
        page++;
      }
      return list;
    },
    build_form(contents, dk_id) {
      const s = this.job.settings || {};
      const product = contents.data.product;
      const seo = contents.data.seo || {};
      const json_table = [];
      try { product.specifications[0].attributes.forEach((v) => json_table.push([v.title, v.values[0]])); } catch (e) {}
      // specs go to dk_specifications/properties only, never into the short description
      const text = {time: Date.now(), blocks: [], version: '2.28.2'};
      const full_text = {time: 1708248359501, blocks: [{id: 'DSM8JadA6h', type: 'paragraph', data: {text: (product.expert_reviews && product.expert_reviews.description) || '', alignment: 'right'}}], version: '2.28.2'};
      let price = '';
      const dkp = dkPrice(product); price = dkp.price;
      const fd = new FormData();
      try { product.images.list.forEach((v) => { if (Number(v.image_id) > 0) fd.append('post_images[]', v.image_id); }); } catch (e) {}
      fd.append('property_group_items', JSON.stringify(s.property_group_items || []));
      try { fd.append('dk_specifications', JSON.stringify(product.specifications || [])); } catch (e) {}
      const dkr = product.rating || {};
      fd.append('dk_id', String(dk_id));
      fd.append('source_url', 'https://www.digikala.com/product/dkp-' + dk_id + '/');
      if (dkr.rate != null) fd.append('dk_rating', dkr.rate > 5 ? Math.round(dkr.rate / 20 * 100) / 100 : dkr.rate);
      if (dkr.count != null) fd.append('dk_rating_count', dkr.count);
      fd.append('product_type', s.product_type);
      fd.append('cat_list', s.value_category || []);
      fd.append('tags', s.value_tags || []);
      if (Number(s.value_brand) > 0) fd.append('brand_id', s.value_brand);
      fd.append('name', product.title_fa);
      fd.append('url', '');
      fd.append('code', String(dk_id));
      fd.append('text', JSON.stringify(text));
      fd.append('full_text', JSON.stringify(full_text));
      fd.append('meta_desc', seo.description || '');
      fd.append('meta_title', seo.title || product.title_fa);
      fd.append('keyword', s.keyword || '');
      fd.append('price', price);
      fd.append('product_stock', s.product_stock || '');
      fd.append('order_point', s.order_point || 0);
      fd.append('product_off_price', typeof dkp !== 'undefined' ? dkp.off : '');
      fd.append('product_off_price_date', '');
      fd.append('selected_currency', s.selected_currency);
      return fd;
    },
    error_text(data) {
      if (!data) return 'پاسخ خالی از سرور';
      return data.msg || data.message || JSON.stringify(data).slice(0, 300);
    },
    async run() {
      const js = this.job.settings || {};
      if (!js.value_category || !js.value_category.length) { this.status_text = 'انتخاب دسته‌بندی محصول الزامی است'; return; }
      this.running = true;
      this.stop = false;
      this.loading_list = true;
      this.status_text = 'در حال خواندن لیست محصولات از دیجی‌کالا...';
      try {
        this.save_max_images();
        this.items = await this.fetch_list(this.job.url, Math.max(1, parseInt(this.job.max) || 1));
        this.persist();
        this.loading_list = false;
        this.status_text = this.items.length + ' محصول پیدا شد';
        const site = (localStorage.getItem('site_url') || '').replace(/\/+$/, '');
        const delay = Math.max(0, parseFloat(this.job.delay) || 0) * 1000;
        this.status_text = 'در حال بررسی محصولات تکراری...';
        let existing = {codes: {}, names: {}, slugs: {}, images: {}};
        try { existing = await this.load_existing(); } catch (e) { console.log(e); }
        this.status_text = this.items.length + ' محصول پیدا شد';
        for (let i = 0; i < this.items.length; i++) {
          if (this.stop) break;
          const it = this.items[i];
          const dup = existing.codes[String(it.dk_id)] || existing.names[this.norm_name(it.title)];
          if (dup) {
            it.state = 'skip';
            it.product_id = dup.id;
            if (site && existing.slugs[dup.id]) it.site_link = site + '/product/' + existing.slugs[dup.id];
            if (existing.images[dup.id]) it.image = existing.images[dup.id];
            this.persist();
            continue;
          }
          it.state = 'working';
          try {
            const fd = new FormData();
            fd.append('url', 'https://www.digikala.com/product/dkp-' + it.dk_id + '/');
            fd.append('download_image', this.job.download_image);
            fd.append('max_images', String(this.max_images));
            const imp = await axios.post('/api/admin/product/import_digikala', fd, {show_pros: false});
            const contents = imp.data;
            const fails = (contents && contents.image_failures) || [];
            if (fails.length) {
              it.img_warn = 'تصاویر ناموفق: ' + fails.length + ' از ' + (contents.image_total || '?');
              it.img_warn_detail = fails.map((x) => '#' + x.index + ' ' + x.reason + ' ' + x.url).join('\n');
              this.$set(it, 'img_fails', fails.map((x) => x.url));
              console.warn('Digikala image failures', it.dk_id, fails);
            }
            if (contents && contents.error == 1) throw new Error(contents.msg || 'خطا در دریافت از دیجی‌کالا');
            if (!contents || !contents.data || !contents.data.product || contents.data.product.is_inactive) {
              throw new Error('محصول در دیجی‌کالا قابل خواندن نیست');
            }
            const importedThumb = this.dk_thumb(contents.data.product);
            if (importedThumb) it.image = importedThumb;
            const res = await axios.post('/api/admin/product/insert_product', this.build_form(contents, it.dk_id), {show_pros: false});
            if (res.data && res.data.error == 0) {
              it.product_id = res.data.id;
              existing.codes[String(it.dk_id)] = {id: res.data.id};
              existing.names[this.norm_name(it.title)] = {id: res.data.id};
              try {
                const info_fd = new FormData();
                info_fd.append('product_id', res.data.id);
                const info = await axios.post('/api/admin/product/get_product_info', info_fd, {show_pros: false});
                const slug = info.data.post.title.slug;
                if (site && slug) it.site_link = site + '/product/' + slug;
                const localThumb = this.gallery_thumb(info.data.post.gallery);
                if (localThumb) {
                  it.image = localThumb;
                  existing.images[res.data.id] = localThumb;
                }
              } catch (e) {}
              it.state = 'ok';
            } else {
              it.state = 'error';
              it.error = this.error_text(res.data);
            }
          } catch (e) {
            it.state = 'error';
            it.error = (e && e.response && e.response.data) ? this.error_text(e.response.data) : (e && e.message ? e.message : String(e));
          }
          this.persist();
          if (i < this.items.length - 1 && delay && !this.stop) await this.sleep(delay);
        }
        this.status_text = this.stop ? 'متوقف شد' : 'پایان انتشار';
      } catch (e) {
        this.loading_list = false;
        this.status_text = 'خطا: ' + (e && e.message ? e.message : e);
      }
      this.items.forEach((x) => { if (x.state === 'waiting') x.state = 'error', x.error = 'انجام نشد (متوقف شد)'; });
      this.persist();
      this.job.status = 'done';
      localStorage.setItem(JOB_KEY, JSON.stringify(this.job));
      this.running = false;
    },
    copy_links() {
      const text = this.items.filter((x) => x.state === 'ok').map((x) => x.title + '\t' + (x.site_link || '')).join('\n');
      if (navigator.clipboard) navigator.clipboard.writeText(text);
    },
  }
}
</script>

<style scoped lang="scss">
.dkb-page {
  padding: 0 0 24px;
  margin-left: -15px;
  margin-right: -15px;
}

.dkb-card {
  background: var(--panel-surface, #fff);
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 16px;
  overflow: hidden;
}

.dkb-hero {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 20px 16px;
  border-bottom: 1px solid var(--panel-border, #e5e7eb);
}

.dkb-hero__main {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
}

.dkb-hero__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #111111;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dkb-hero__icon .c-icon {
  width: 22px;
  height: 22px;
  color: #fff !important;
}

.dkb-hero__title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: var(--panel-text, #111827);
  line-height: 1.3;
}

.dkb-hero__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--panel-muted, #6b7280);
}

.dkb-hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dkb-source {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  background: var(--panel-surface-2, #f8fafc);
  border-bottom: 1px solid var(--panel-border, #e5e7eb);
  min-width: 0;
}

.dkb-source__label {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .04em;
  color: var(--panel-muted, #6b7280);
  text-transform: uppercase;
}

.dkb-source__link {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: var(--panel-accent, #2563eb);
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dkb-source__link:hover {
  text-decoration: underline;
}

.dkb-stats {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
  padding: 16px 20px 0;
}

.dkb-stat {
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 12px;
  padding: 12px 10px;
  text-align: center;
  background: var(--panel-surface, #fff);
  cursor: pointer;
  font-family: inherit;
  transition: border-color .15s ease, background .15s ease;
}

.dkb-stat:hover { background: var(--panel-surface-2, #f8fafc); }
.dkb-stat.active { border-color: #111111; background: #f9fafb; }

.dkb-stat__value {
  display: block;
  font-size: 22px;
  font-weight: 800;
  color: var(--panel-text, #111827);
  line-height: 1.1;
}

.dkb-stat__label {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  font-weight: 600;
  color: var(--panel-muted, #6b7280);
}

.dkb-stat--ok .dkb-stat__value { color: #16a34a; }
.dkb-stat--skip .dkb-stat__value { color: #d97706; }
.dkb-stat--err .dkb-stat__value { color: #dc2626; }

.dkb-progress {
  padding: 14px 20px 0;
}

.dkb-progress__track {
  height: 8px;
  border-radius: 99px;
  background: var(--panel-surface-2, #f1f5f9);
  overflow: hidden;
}

.dkb-progress__bar {
  height: 100%;
  border-radius: 99px;
  background: #111111;
  transition: width .35s ease;
}

.dkb-progress__meta {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--panel-muted, #6b7280);
}

.dkb-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
}

.dkb-field {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.dkb-field__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--panel-text, #364a63);
}

.dkb-field__input {
  width: 84px;
  height: 36px;
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 10px;
  padding: 0 10px;
  font-family: inherit;
  font-size: 13px;
  background: var(--panel-surface, #fff);
  color: var(--panel-text, #111827);
}

.dkb-field__input:focus {
  outline: none;
  border-color: #111111;
}

.dkb-field__input:disabled {
  opacity: .55;
}

.dkb-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 6px 12px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--panel-text, #364a63);
  background: var(--panel-surface-2, #f8fafc);
  border: 1px solid var(--panel-border, #e5e7eb);
}

.dkb-status--live {
  border-color: rgba(37, 99, 235, .25);
  background: rgba(37, 99, 235, .06);
  color: #1d4ed8;
}

.dkb-status__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2563eb;
  animation: dkb-pulse 1.2s ease infinite;
}

.dkb-status__spin {
  width: 14px !important;
  height: 14px !important;
}

@keyframes dkb-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: .35; transform: scale(.85); }
}

.dkb-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 0 20px 12px;
}

.dkb-filter {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  padding: 0 12px;
  border-radius: 99px;
  border: 1px solid var(--panel-border, #e5e7eb);
  background: var(--panel-surface, #fff);
  color: var(--panel-text, #364a63);
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.dkb-filter:hover { background: var(--panel-surface-2, #f8fafc); }

.dkb-filter.active {
  background: #111111;
  border-color: #111111;
  color: #fff;
}

.dkb-filter__count {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 99px;
  background: rgba(0, 0, 0, .06);
  font-size: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.dkb-filter.active .dkb-filter__count {
  background: rgba(255, 255, 255, .18);
}

.dkb-filters__clear {
  margin-right: auto;
}

.dkb-skel {
  padding: 0 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dkb-skel__row {
  height: 56px;
  border-radius: 12px;
  background: linear-gradient(90deg, var(--surface-3, #eef0f3) 25%, var(--surface-2, #f7f8fa) 37%, var(--surface-3, #eef0f3) 63%);
  background-size: 400% 100%;
  animation: dkb-shimmer 1.4s ease infinite;
}

@keyframes dkb-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

.dkb-list {
  list-style: none;
  margin: 0;
  padding: 0 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.dkb-item {
  display: grid;
  grid-template-columns: 28px 48px minmax(0, 1fr) auto auto;
  gap: 10px;
  align-items: center;
  min-height: 56px;
  padding: 8px 10px;
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 12px;
  background: var(--panel-surface, #fff);
  box-shadow: none;
}

.dkb-item.is-working {
  border-color: rgba(37, 99, 235, .35);
  background: rgba(37, 99, 235, .04);
}

.dkb-item.is-ok { border-color: rgba(22, 163, 74, .22); }
.dkb-item.is-error { border-color: rgba(220, 38, 38, .2); }
.dkb-item.is-skip { border-color: rgba(217, 119, 6, .22); }

.dkb-item__index {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background: var(--panel-surface-2, #f1f5f9);
  color: var(--panel-muted, #6b7280);
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.dkb-item__thumb {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--panel-border, #e5e7eb);
  background: var(--panel-surface-2, #f8fafc);
  flex-shrink: 0;
}

.dkb-item__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.dkb-item__thumb-ph {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--panel-muted, #9ca3af);
}

.dkb-item__thumb-ph .c-icon {
  width: 18px;
  height: 18px;
}

.dkb-item__main {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  overflow: hidden;
}

.dkb-item__title {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: 700;
  color: var(--panel-text, #111827);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dkb-item__state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 64px;
}

.dkb-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  padding: 0 10px;
  border-radius: 99px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  background: var(--panel-surface-2, #f1f5f9);
  color: var(--panel-muted, #6b7280);
}

.dkb-badge--ok { background: rgba(22, 163, 74, .12); color: #15803d; }
.dkb-badge--error { background: rgba(220, 38, 38, .12); color: #b91c1c; }
.dkb-badge--skip { background: rgba(217, 119, 6, .12); color: #b45309; }
.dkb-badge--waiting { background: var(--panel-surface-2, #f1f5f9); color: #6b7280; }
.dkb-badge--working { background: rgba(37, 99, 235, .12); color: #1d4ed8; }

.dkb-chip {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  background: var(--panel-surface-2, #f1f5f9);
  color: var(--panel-muted, #6b7280);
}

.dkb-hint {
  flex-shrink: 1;
  min-width: 0;
  font-size: 11px;
  color: var(--panel-muted, #6b7280);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

.dkb-hint--err { color: #dc2626; }
.dkb-hint--warn { color: #d97706; }

.dkb-item__actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px;
  justify-content: flex-end;
}

.dkb-empty--soft {
  padding: 28px 20px 36px;
}

.dkb-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 36px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none !important;
  transition: background .15s ease, color .15s ease, border-color .15s ease, transform .12s ease;
  white-space: nowrap;
  background: transparent;
  color: inherit;
}

.dkb-btn .c-icon {
  width: 16px;
  height: 16px;
}

.dkb-btn:active { transform: scale(.98); }
.dkb-btn:disabled { opacity: .55; cursor: not-allowed; }

.dkb-btn--primary {
  background: #111111 !important;
  color: #fff !important;
  border-color: #111111 !important;
}

.dkb-btn--primary .c-icon { color: #fff !important; }

.dkb-btn--ghost {
  background: var(--panel-surface-2, #f7f8fb);
  color: var(--panel-text, #364a63);
  border-color: var(--panel-border, rgba(128, 148, 174, .2));
}

.dkb-btn--ghost:hover {
  background: #f3f4f6;
  color: #111111;
}

.dkb-btn--danger {
  background: rgba(220, 38, 38, .08);
  color: #dc2626;
  border-color: rgba(220, 38, 38, .25);
}

.dkb-btn--warn {
  background: rgba(217, 119, 6, .1);
  color: #b45309;
  border-color: rgba(217, 119, 6, .25);
}

.dkb-btn--sm {
  min-height: 30px;
  padding: 4px 10px;
  font-size: 12px;
}

.dkb-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 56px 20px;
  text-align: center;
}

.dkb-empty__icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--panel-surface-2, #f1f5f9);
  color: var(--panel-muted, #6b7280);
  margin-bottom: 4px;
}

.dkb-empty__icon .c-icon {
  width: 24px;
  height: 24px;
}

.dkb-empty__title {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: var(--panel-text, #111827);
}

.dkb-empty__sub {
  margin: 0 0 8px;
  max-width: 360px;
  font-size: 13px;
  color: var(--panel-muted, #6b7280);
  line-height: 1.6;
}

@media (max-width: 767.98px) {
  .dkb-item {
    grid-template-columns: 24px 44px minmax(0, 1fr) auto;
    grid-template-areas:
      "idx thumb main state"
      "actions actions actions actions";
  }
  .dkb-item__index { grid-area: idx; }
  .dkb-item__thumb { grid-area: thumb; width: 44px; height: 44px; }
  .dkb-item__main { grid-area: main; }
  .dkb-item__state { grid-area: state; min-width: 0; }
  .dkb-item__actions {
    grid-area: actions;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding-top: 4px;
  }
}

@media (max-width: 767.98px) {
  .dkb-stats {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .dkb-hero__title {
    font-size: 17px;
  }
  .dkb-filters__clear {
    margin-right: 0;
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .dkb-status__dot,
  .dkb-skel__row,
  .dkb-progress__bar {
    animation: none !important;
    transition: none !important;
  }
}
</style>
